import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e2a3595 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _6186f3a3 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _34a752a3 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _b28cdbf0 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _fa8ef3f8 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _01f66233 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _519cb83f = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _4d28dbbd = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _6ef29205 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _1e2fe90a = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _a7b3f2a0 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _f8d201a0 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _637e55db = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _20bae4b2 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _169c13cd = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _25dccd08 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _4b308472 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _d9c53726 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _461a5540 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _8c624f7c = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _3e2a3595,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _6186f3a3,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _34a752a3,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _b28cdbf0,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _fa8ef3f8,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _01f66233,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _01f66233,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _01f66233,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _519cb83f,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _4d28dbbd,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _6ef29205,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _4d28dbbd,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _6ef29205,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _1e2fe90a,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _1e2fe90a,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _1e2fe90a,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _1e2fe90a,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _1e2fe90a,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _1e2fe90a,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _1e2fe90a,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _a7b3f2a0,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _a7b3f2a0,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _f8d201a0,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _637e55db,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _637e55db,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _20bae4b2,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _169c13cd,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _25dccd08,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _25dccd08,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _4b308472,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _d9c53726,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _461a5540,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _8c624f7c,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
